import type { UnknownObj } from '@repo/internal-tools-type-utils/src/primitives.ts'
import { flatten, unflatten } from 'flat'
import { deepMergeTwo } from '../deepMerge/deepMerge.ts'

export type RedactValuesFromObjectOptions = {
  redactString?: string
  mutate?: boolean
}

export const redactValuesFromObject = <Obj extends UnknownObj>(
  object: Obj,
  valuesToRedact: Array<string>,
  {
    redactString = '######',
    mutate = false,
  }: RedactValuesFromObjectOptions = {},
) => {
  const flatObject = flatten<Obj, UnknownObj>(object)
  const lowerCasedValuesToRedact = valuesToRedact.map((item) =>
    item.toLowerCase().trim(),
  )
  const redactedFlatObjectEntries = Object.entries(flatObject).map(
    ([key, value]) => {
      const shouldValueBeRedacted = key
        .split('.')
        .some((item, index, array) => {
          const isLast = index === array.length - 1
          if (!isLast) {
            return false
          }
          return lowerCasedValuesToRedact.includes(
            item.toLocaleLowerCase().trim(),
          )
        })
      if (shouldValueBeRedacted) {
        return [key, redactString] as const
      }
      return [key, value] as const
    },
  )
  const redactedFlatObject = Object.fromEntries(redactedFlatObjectEntries)
  const redactedObject = unflatten<typeof redactedFlatObject, typeof object>(
    redactedFlatObject,
  )

  if (mutate) {
    deepMergeTwo(object, redactedObject, { mutate })
    return object
  }

  return redactedObject
}

export default redactValuesFromObject
